import { toast } from 'react-toastify';
import s from '../allservices.jsx';
import { getClientId, getClientSecret,buildClientHeader } from '../../utils/clientAuth.js';

const getCardService = (actionCallback, state) => {
    let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
    let token = "Token " + localStorage.getItem('token')
    let traceId = getClientId();
    fetch(plink+ s.get_cards, {
        method: "POST",
        headers: {
            'content-type': 'application/json',
            'Authorization': token,
            'X-Trace-Id': traceId,
            'X-Client-APP':buildClientHeader(),
        },
        body: JSON.stringify(state)
    })
        .then(res => {
            if (res.status === 200 || res.status === 201  || res.status === 304) {
                res.json().then(json => actionCallback(json, "success"))
                
            }
            else if(res.status === 204){
               let data="No cards for this user."
                actionCallback(data,"emptyBody")
            }
             else if (res.status === 401) {
           
            //     localStorage.clear();
            //     this.props.history.push("/")
            let errorOut= "logout"
            actionCallback(errorOut)
            }
            else {
                // 
                actionCallback(res.headers.get('message'),"error")
                toast.error(res.headers.get('message'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 2000,
                    newestOnTop: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                }); 
            }
        })
}

export default getCardService;


// WEBPACK FOOTER //
// ./src/services/components/get_card.jsx